import { useNavigate } from 'react-router-dom';
import { FaEdit, FaEye, FaLock } from 'react-icons/fa';
import { FaTrash } from 'react-icons/fa';
import { deleteChallenge } from '../../../api/challenge';
import Chip from '../../../components/Chip';
const ChallengeListTable = ({ data, setData, toast, isLoading, onViewImpact }) => {

    const navigate = useNavigate();

    const renderChips = (item) => {
        if (item.active) {
            return (
                <Chip value={'Active'} color='green' variant='filled' />
            );
        }
        else if (item.active === false) {
            return (
                <Chip value={'Inactive'} color='inactive' variant='filled' />
            );
        }
    }

    if (isLoading) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-xl text-gray-400">Loading...</h1>
            </div>
        );
    }

    if (!isLoading && data.length === 0) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-base">No data available</h1>
            </div>
        );
    }

    const handleDelete = (id) => {
        const conf = window.confirm('Are you sure you want to delete this challenge?');
        if (conf) {
            deleteChallenge(id, setData, toast);
        }
    }

    return (
        <div className="overflow-x-auto px-6">
            <table className="w-full border-collapse" role="table">
                <thead className="bg-navBtn">
                    <tr className="rounded-md">
                        <th className="p-3 text-left">Srl. No.</th>
                        <th className="p-3 text-left">Category</th>
                        <th className="p-3 text-left">Name</th>
                        {/* <th className="p-3 text-left">Complexity</th> */}
                        <th className="p-3 text-center">Total Points</th>
                        <th className="p-3 text-center">Carbon Saving Points</th>
                        <th className="p-3 text-center">Submission Points</th>
                        <th className="p-3 text-center">Bonus Points</th>
                        <th className="p-3 text-center">Pages/Questions</th>
                        <th className="p-3 text-center">Users</th>
                        {/* <th className="p-3 text-center">Submissions</th> */}
                        <th className="p-3 text-center">Created At</th>
                        <th className="p-3 text-center">Status</th>
                        <th className="p-3 text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, id) => (
                        <tr
                            key={item._id}
                            className="border-b border-navBtn hover:bg-gray-50 relative font-normal"
                        >
                            <td className="p-3 text-center">{++id}</td>
                            <td className="p-3">{item.category.length === 0 ? 'Unknown' : item.category.name}</td>
                            <td className="p-3">
                                {
                                    item?.isSponsored && 
                                    <>
                                        <Chip value='Sponsored' color='blue' small={true} />
                                        <br />
                                    </>
                                }
                                {item.name}<br />
                                <p className='text-secondary capitalize'>
                                    ({item.complexity})
                                </p>
                            </td>
                            {/* <td className="p-3">{item.complexity}</td> */}
                            <td className="p-3 text-center relative group">
                                {(item.points + item.bonusPoints + (item?.carbonSavingPoints || 0))}
                                <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block bg-[rgba(0,122,155,1)] text-white text-xs rounded py-1 px-2 z-40">
                                    <table>
                                        <tr>
                                            <th className='text-nowrap px-2 pt-2 text-center'>Carbon Saving Points</th>
                                            <th className='text-nowrap px-2 pt-2 text-center'>Submission Points</th>
                                            <th className='text-nowrap px-2 pt-2 text-center'>Bonus Points</th>
                                        </tr>
                                        <tr>
                                            <td className='px-2 pb-2'>
                                                {item?.carbonSavingPoints ?? "-"}
                                            </td>
                                            <td className='px-2 pb-2'>
                                                {item.points}
                                            </td>
                                            <td className='px-2 pb-2'>
                                                {item.bonusPoints}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </td>
                            <td className="p-3 text-center">{item?.carbonSavingPoints ?? "-"}</td>
                            <td className="p-3 text-center">{item.points}</td>
                            <td className="p-3 text-center">{item.bonusPoints}</td>
                            <td className="p-3 text-center">{item.totalPages} P / {item.totalQuestions} Q</td>
                            <td className="p-0 text-center place-items-center">
                                <p className='text-nowrap'>
                                    {item.submissionCount} Submitted
                                </p>
                                {/* <hr className='border-secondary py-0.5' /> */}
                                <p className='text-nowrap text-secondary'>
                                    ({item.peopleJoined} Enrolled)
                                </p>
                            </td>
                            {/* <td className="p-0 text-center place-items-center">
                                {item.submissionCount}
                            </td> */}
                            <td className="p-2 text-center place-items-center">
                                <p>
                                    {new Date(item?.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                </p>
                                <p>
                                    {new Date(item?.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                </p>
                            </td>
                            <td className="p-0 text-center place-items-center">
                                {/* <div className={`flex justify-end items-center border ${item?.active ? `border-primary` : `border-inactive`} rounded-md h-full min-h-8`}>
                                <label className="inline-flex items-center me-2 h-full">
                                    <span className={`ms-2 text-base ${item?.active ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{item?.active ? 'Active' : 'Inactive'}</span>
                                    <input type="checkbox" name={'active'} value={item?.active} className="sr-only peer" checked={item?.active} />
                                    <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                                </label>
                            </div> */}
                                {renderChips(item)}
                            </td>
                            <td className="p-3 text-center text-nowrap gap-1">
                                {/* Eye Icon for Attached Product Impact */}
                                {item?.attachedProduct && (
                                    <button
                                        className="rounded p-1.5 bg-[#29abe233] hover:bg-[#29abe244] min-h-7 relative group mr-1"
                                        onClick={() => onViewImpact && onViewImpact(item)}
                                    >
                                        <FaEye className="text-chipBlue" />
                                        <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block bg-chipBlue text-white text-xs rounded py-1 px-2">
                                            View Impact
                                        </span>
                                    </button>
                                )}
                                
                                <button
                                    className="rounded p-1.5 bg-[rgba(0,122,155,0.1)] hover:bg-[rgba(0,122,155,0.2)] min-h-7 relative group"
                                    onClick={() => navigate('/challenges/challenges-main/edit-challenge', { state: { _id: item._id } })}
                                >
                                    <FaEdit className='text-[rgba(0,122,155,0.5)]' />
                                    <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 hidden group-hover:block bg-[rgba(0,122,155,0.5)] text-white text-xs rounded py-1 px-2">
                                        Edit
                                    </span>
                                </button>
                                <button className="rounded p-1.5 bg-[rgba(250,22,22,0.1)] hover:bg-[rgba(250,22,22,0.2)] min-h-7 relative group" onClick={() => handleDelete(item._id)} disabled={item.submissionCount > 0 ? true : false}>
                                    {
                                        item.submissionCount > 0 ?
                                            <FaLock className='text-[rgba(250,22,22,0.5)]' />
                                            : <FaTrash className='text-[rgba(250,22,22,0.5)]' />
                                    }
                                    <span className="absolute bottom-full mb-1 hidden group-hover:block bg-inactive text-white text-xs rounded py-1 px-2 right-0">
                                        {item.submissionCount > 0 ? `${item.submissionCount} users have already submitted this challenge hence you cannot delete it, please inactive it if you don't want it to display anywhere` : 'Delete'}
                                    </span>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default ChallengeListTable;